/**
 * created by wang lei
 资源库导入 页面
 *
 */
import React, {Component} from 'react';
import {Checkbox, Input, Modal} from "antd";
import BaseTable from "../../../../../components/baseTable/BaseTable";
import { Pagination , Radio } from 'antd';
import BaseComponent from "../../../../../../base/BaseComponent";
import moment from "moment";
import $ from "jquery";
import contentHandle from "../../../../util/content/contentHandle";
const { Search } = Input;

export default class ResourceImport extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            total:"1",
            page:1,
            valueSearch:'',
            wordsNum:0,
            checked:false,
            count:0,
            columns: [
                {
                    title: '',
                    dataIndex: 'radio',
                    key: 'radio',
                    width: 50,
                    render:(text,record,index)=>{
                        return(
                            <Radio.Group onChange={(e)=>{
                                this.setState({record})
                                this.setState({value: e.target.value})
                            }}
                                value={this.state.value}>
                                <Radio value={record.id}></Radio>
                            </Radio.Group>
                        )
                    }
                },
                {
                    title: '文章标题',
                    dataIndex: 'title',
                    key: 'title',
                    width: 200,
                    ellipsis: true,
                },
                {
                    title: '来源',
                    dataIndex: 'codeName',
                    key: 'codeName',
                    width: 150,
                    ellipsis: true,
                },
                {
                    title: '日期',
                    dataIndex: 'createTime',
                    key: 'createTime',
                    width: 200,
                    ellipsis: true,
                    render: (text) => {
                        return (
                            <div>
                                {text ? moment(text).format('YYYY-MM-DD HH:mm:ss') : ''}
                            </div>
                        )
                    }
                },
                {
                    title: '作者',
                    dataIndex: 'submitterName',
                    key: 'submitterName',
                    width: 100,
                    ellipsis: true,
                    render: (text,record) => {
                        let data = record?.variableFields?.author;
                        return (
                            <div>
                                {data ? data : text}
                            </div>
                        )
                    }
                },
                {
                    title: '字数',
                    dataIndex: 'wordsNum',
                    key: 'wordsNum',
                    width: 100,
                    ellipsis: true,
                    render: (text) => {
                        return (
                            <div>
                                {text ? text : "0"}
                            </div>
                        )
                    }
                },
                {
                    title: '图片数',
                    dataIndex: 'pictureNum',
                    key: 'pictureNum',
                    width: 100,
                    ellipsis: true,
                    render: (text) => {
                        return (
                            <div>
                                {text ? text : "0"}
                            </div>
                        )
                    }
                },
            ],
            dataList: []
        }
    }

    handleCancel = () => {
        if (typeof this.props.onCloseCall === 'function') {
            this.props.onCloseCall()
        }
        this.setState({
            visible: false
        });
    };
    handleOk = e => {
        if(typeof this.props.onCloseCall === 'function') {
            this.props.onCloseCall()
        }
        if(this.state.record){
            this.wordImport(this.state.record.content,(content)=>{
                this.props.editor.setContent(content);
                this.props.editor.setCurrentInformation(this.state.record);
                window.loading.hide();
            })
        }
        this.setState({
            visible: false,
        });
    };
    removeStyleDom = (html) => {
        // 处理html标签
        html = html.replace(/html/g,'rmt_html').replace(/head/g,'rmt_head').replace(/body/g,'rmt_body');
        // 创建虚拟的父元素并将HTML内容作为子元素
        const $parent = $("<div>").html(html);
        // 获取所有style标签的内容
        let styles = $parent.find("style").text();
        if(styles?.length) {
            styles = styles.replace(/\n/g,'');
        } else {
            return html
        }
        // 移除所有style标签
        $parent.find("style").remove();
        $parent.find("title").remove();
        let styleArr = styles.split('}');
        styleArr?.length && styleArr.forEach(style=>{
            if(style) {
                let c = style.split('{');
                if(c.length === 2) {
                    let cla = c[0];
                    let css = c[1];
                    if(cla && css) {
                        if($parent.find(cla)) {
                            $parent.find(cla).attr("style", function (index, oldStyle) {
                                return  "" + css + (oldStyle || "");
                            });
                        }
                    }
                }
            }
        });
        // 获取处理后的HTML
        let processedHtml = $parent.html();
        // 处理html标签
        processedHtml = processedHtml.replace(/rmt_html/g,'html').replace(/rmt_head/g,'head').replace(/rmt_body/g,'body');
        return processedHtml
    };
    wordImport = (data,call)=>{
        if(!data){
            call(data)
            return false;
        }
        if(data && data.includes("<style")) {
            // 过滤style标签
            data = this.removeStyleDom(data);
        }
        let srcList = [];
        $(`<div>${data}</div>`).find("img").each(function(){
            let src = $(this).attr("src");
            if(src){
                srcList.push(src);
            }
        });
        let fun = (picList)=>{
            // 存在导入的word每一段外面都是div，但是没有最外层div，所以这里暂不能直接去掉最外层div
            let handleNames = window.sysConfig && window.sysConfig.getValueByKey && window.sysConfig.getValueByKey("editor.content.word.import.after.handler.names", 'removeTopDivMore,changeImage,removeA');
            let handleNamesArr = handleNames.split(",");
            // 因jq无法解析html和body标签，所以这里将相关标签进行转移
            handleNamesArr.unshift("addHtmlAndBody");
            // 结束时对html和body进行还原
            handleNamesArr.push("removeHtmlAndBody");
            let content = contentHandle(handleNamesArr, data, picList);
            call(content)
        };
        if(srcList.length === 0){
            fun([]);
        }else{
            window.loading.show(true);
            this.request({
                url: "/storage/getStorageFileListByUrls",
                body:{
                    urls: srcList.join(",")
                },
                method:"post",
                loading:false,
                callBack:(picList)=>{
                    fun(picList);
                }
            });
        }
    };


    showModal = () => {
        let typeList = eval(this.sysConfigGetValueByKey("editor.resource.import.source.list", "['1','2','3']"));//哪些类型的媒体可以导入
        this.getList({
            pageNum: this.state.page,
            pageSize: 6,
            typeList
        })
        this.setState({
            visible: true
        })
    }

    render() {
        return (
            <Modal
                title="资源库导入"
                visible={this.state.visible}
                onCancel={()=>{
                    this.handleCancel()
                }}
                maskClosable={false}
                onOk={this.handleOk}
                width={"1000px"}
                height={"661.77px"}
                bodyStyle={{padding: '24px 0'}}
            >
                <div style={{height:"495px",width:"100%"}}>
                    <div style={{fontSize:"14px",color:'#666666',display:"flex",justifyContent:"space-between",marginBottom:'24px',padding:"0 24px"}}>
                        <Search
                            placeholder="请输入"
                            onSearch={valueSearch => {
                                this.setState({valueSearch},()=>{
                                    this.state.page=1;
                                    this.getDataSource();
                                    // this.getList({
                                    //     pageNum: this.state.page,
                                    //     pageSize: 6,
                                    //     keyword: this.state.valueSearch
                                    // })
                                })
                            }}
                            style={{ width:'224px',height:'32px'}}
                        />
                        <div>
                            <Checkbox style={{paddingRight: '8px'}}
                                      checked={this.state.checked}
                                      onChange={(e) => {
                                          this.setState({checked:e.target.checked},()=>{
                                              this.state.page=1;
                                              this.getDataSource();
                                          })

                                      }}

                            />
                            <span style={{paddingRight:'24px'}}>仅我的资源</span>
                            <span>共</span>
                            <span style={{color:"#0050B3"}}>{this.state.count}</span>
                            <span>条记录</span>
                        </div>
                    </div>
                    <div style={{height:380,padding:"0 24px"}}>
                        <BaseTable columns={this.state.columns} dataSource={this.state.dataSource && this.state.dataSource} >
                        </BaseTable>
                    </div>
                    {this.state.count === 0 ? null :
                        <div style={{padding: "24px 24px 0 24px", borderTop: '1px solid #EEEEEE'}}>
                            <Pagination current={this.state.page}
                                        showQuickJumper={true}
                                        total={this.state.count}
                                        pageSize={6}
                                        showTotal={total => `共 ${this.state.count} 条`}
                                        style={{display: 'flex', justifyContent: 'flex-end'}}
                                        onChange={(page) => {
                                            this.state.page = page
                                            this.getDataSource()
                                        }}
                            />
                        </div>}

                </div>
            </Modal>
        )
    }
    getDataSource=()=>{
        let typeList = eval(this.sysConfigGetValueByKey("editor.resource.import.source.list", "['1','2','3']"));//哪些类型的媒体可以导入
        if(this.state.checked){
            this.getList({
                pageNum: this.state.page,
                pageSize: 6,
                keyword: this.state.valueSearch,
                submitter:window.currentUser.id,
                typeList
            });
        }else{
            this.getList({
                pageNum: this.state.page,
                pageSize: 6,
                keyword: this.state.valueSearch,
                typeList
            });
        }
    }
    getList(params) {
        this.request({
            url: '/search-server/search/getList/story/zyk',
            method: "POST",
            body: params,
            contentType: "json",
            callBack: (data) => {
                let dataSource =[]
                let count =[]
                let submitter =[]
                if(data){
                    dataSource = data.data;
                    count = data.count;
                }
                this.setState({dataSource,count,submitter})
            }
        });
    }
}